module.exports = __webpack_public_path__ + "app/principal/reports-eqUL1dWC.html";